/**
 * Dynamic routing setup - only load code for a route when its needed
 * @see https://github.com/rackt/react-router/blob/master/docs/guides/advanced/DynamicRouting.md
 */

import { redirectRoute } from './helpers';
import App from '../components/App';
import { PointStages } from '../constants/AppConstants';
import AppActions from '../actions/AppActions';

const rootRoute = {
    component: App,
    path: '/',

    //Redirect / to /search
    indexRoute: redirectRoute(null, PointStages.SEARCH),

    onEnter ({ location }) {
        if (location.query) {
            const featureFlags = Object.keys(location.query)
                .filter((param) => param.startsWith('feature.'));
            featureFlags.forEach((param) => {
                const feature = param.replace('feature.', '');
                const featureValue = location.query[param];
                AppActions.toggleFeature(feature, !!featureValue.match(/^(?:yes|true|on|1)$/i));
            });
        }
    },

    childRoutes: [
        require('./Point/Init'),
        require('./Point/Search'),
        require('./Point/Results'),
        require('./Point/SearchResults'),
        require('./ServiceList'),
        require('./Grid/Services'),

        require('./Checkout/Delivery'),
        require('./Checkout/Payment'),
        require('./Checkout/PaymentConfirmation'),

        require('./Account'),
        require('./Account/Smartcard/AssociationConfirmation'),

        require('./Season/Init'),
        require('./Season/Search'),
        require('./Season/Results'),

        require('./OtherTickets'),
        require('./DaySave/Search'),
        require('./DaySave/Results'),
        require('./RoversRangers/Search'),
        require('./RoversRangers/Results'),
        require('./SmartCarnet/SmartCarnetResultsRoute'),

        require('./Promotion'),
        require('./Promotion/Apply'),

        require('./Login/Reset'),
        require('./Login/SetPasswordAndPreferences'),

        require('./Newsletter/Unsubscribe'),

        require('./NRE'),

        require('./OtherPages'),

        require('./SearchWidget'),

        require('./InApp'),

        require('./WidgetAuth'),

        require('./HandOff/Fare'),

        require('./SelfSmartcard'),

        require('./DisruptionAlerts'),

        require('./TimetableAlerts'),

        require('./Widget/OpenGolfWidget'),
        require('./Widget/OpenGolfTimetableWidget'),
        require('./Widget/OpenGolfTicketSelection'),
        require('./Widget/RefundWidget'),

        //Any not found route goes to search
        redirectRoute('/**', PointStages.SEARCH)

    ].filter((x) => !!x) //Remove any null routes
};

export default rootRoute;



// WEBPACK FOOTER //
// ./src/routes/index.js